var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[(_vm.copyright)?_c('navigation'):_vm._e(),(_vm.ifNew)?_c('router-view',{key:_vm.$route.fullPath,staticClass:"router-box"}):_vm._e(),_c('footer',{staticClass:"footer"},[(_vm.copyright)?_c('footers'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }